module.exports = __webpack_public_path__ + "img/nav_referral.e3e30040.svg";